import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';

export function ProductCard({ product }) {
  const { getLocalizedField } = useLanguage();

  // Handle both Supabase nested category and mock data category_id
  const category = product.category || null;

  return (
    <Link 
      to={`/product/${product.slug}`}
      className="group block"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative aspect-[3/4] overflow-hidden rounded-sm bg-[#E5E5E5]">
        <img
          src={product.image_url}
          alt={getLocalizedField(product, 'name')}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {/* Category Badge */}
        {category && (
          <span className="absolute top-4 left-4 font-sans text-xs uppercase tracking-widest text-white bg-black/50 backdrop-blur-sm px-3 py-1 rounded-full">
            {getLocalizedField(category, 'name')}
          </span>
        )}
      </div>
      <div className="mt-4 space-y-1">
        <h3 className="font-serif text-lg md:text-xl text-[#2C2C2C] group-hover:text-[#8B5A2B] transition-colors">
          {getLocalizedField(product, 'name')}
        </h3>
        {product.price && product.price < 2000 && (
          <p className="font-sans text-sm text-[#5D5D5D]">
            {product.price.toLocaleString('de-DE', { style: 'currency', currency: product.currency || 'EUR' })}
          </p>
        )}
      </div>
    </Link>
  );
}
